import React from 'react'

const Quote = () => {
  return (
    <div className='w-[90%]  mx-auto flex justify-center items-center '>
        
        <img src="/info/quoteone.svg" alt="" className='w-[40%] h-[200px] md:h-[300px] lg:h-[400px] xl:h-[500px]' />
        <img src="/info/quotetwo.svg" alt="" className='w-[60%] h-[200px] md:h-[300px] lg:h-[400px] xl:h-[500px]' />
    </div>
  )
}

export default Quote